import * as React from 'react';
import { Button, Row, Label } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import { PersonPoster } from './components/PersonPoster';
import { match } from 'react-router';
import { ICase } from 'src/share/types/case/case';
import { IAgency } from 'src/share/types/agency';
import { BeatLoader } from 'react-spinners';
import { momentToString } from 'src/share/utils/utils';
import { IAuthState } from 'src/modules/Auth/store/types';
import { getAgenciesFromCase } from 'src/share/utils/getAgenciesFromCase';
import PosterPrint from '../PosterPrint/PosterPrint';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { WrappedInput } from 'src/share/components/Input/Input';
import { getContactInformation } from 'src/share/utils/formatContactInfo';
import './poster.css'

export interface IPosterProps {
  match: match<{ caseId: string }>
  caseData: ICase;
  loading: boolean;
  auth: IAuthState;
}
export interface IPosterState {
  agencies: IAgency[];
  crossBorderAgency: string;
  showPrint: boolean;
}

export default class Poster extends React.Component<IPosterProps, IPosterState> {
  constructor(props: IPosterProps) {
    super(props);
    this.state = {
      agencies: [],
      crossBorderAgency: '',
      showPrint: false
    }
  }

  public static getDerivedStateFromProps(props: IPosterProps): Partial<IPosterState> {
    const agencies = getAgenciesFromCase(props.caseData).reduce((agenciesArray, agencyCode) => {
      const agency = props.auth.agencies.find(agencyData => agencyData.code === agencyCode)
      if (agency) {
        agenciesArray.push(agency)
      }
      return agenciesArray;
    }, [] as IAgency[])
    return { agencies }
  }

  public onPrint() {
    this.setState({ showPrint: false });
    window.print();
  }

  public modalToggle = () => {
    this.setState({ showPrint: !this.state.showPrint })
  }

  public getAgenciesOptions() {
    return this.state.agencies.map((agency) => {
      return <option key={agency.code} value={agency.code}>{agency.name}</option>
    });
  }

  public onChangePosterAgency = (crossBorderAgency: string) => {
    this.setState({ crossBorderAgency })
  }

  public getPosterPrintAgency(isCrossBorderAgencies: boolean) {
    const { caseData: { agencyCode } } = this.props;
    const { agencies, crossBorderAgency } = this.state;
    return agencies.find(agencyData => agencyData.code === `${isCrossBorderAgencies ? crossBorderAgency || agencyCode : agencyCode}`) as IAgency;
  }

  public render() {
    const { caseData: { contactInformation, children, abductors, country, state, city, circumstances, poster, lastSeen, missingDate, miscellaneous }, loading } = this.props;
    const { agencies, crossBorderAgency, showPrint } = this.state;
    const isCrossBorderAgencies = agencies.length > 1;
    return (
      <>
        <div className="posterContent">
          <div className="help-loader">
            <BeatLoader loading={loading} />
          </div>
          {
            !loading &&
            <div className="card white-background">
              <div className="posterTitle">
                {poster || 'Missing'}
              </div>
              <div className="content">
                <Row>
                  <div className="col-md-6 col-sm-12 persons">
                    {children.map((child) => <PersonPoster person={child} key={child.childId} />)}
                    {abductors.map((abductor) => <PersonPoster person={abductor} key={abductor.abductorId} />)}
                  </div>
                  <div className="col-md-6 col-sm-12 data">
                    <p><Label>Missing date:</Label>{missingDate && momentToString(missingDate) || "unknown"}</p>
                    <p><label>Location:</label>{`${state ? state + ', ' : ''}${city ? city + ', ' : ''}${country || ''}`}</p>
                    <p><label>Last seen:</label>{lastSeen || "unknown"}</p>
                    <p className="full-line"><Label>Circumstances:</Label></p>
                    <p className="circumstances">
                      {circumstances ? circumstances : 'unknown'}
                    </p>
                    <p className="full-line"><Label>Contact information:</Label></p>
                    <p className="case-circumstances">
                      {contactInformation ? ReactHtmlParser(getContactInformation(contactInformation)) : 'unknown'}
                    </p>
                    {
                      agencies.map(agency => {
                        return agency && agency.code !== this.props.caseData.agencyCode && (
                          <>
                            <p className="full-line"><Label className="country">In {agency.country}:</Label></p>
                            <p className="circumstances">
                              {agency.contact ? ReactHtmlParser(getContactInformation(agency.contact)) : 'unknown'}
                            </p>
                          </>
                        )
                      })
                    }
                    {
                      agencies.map(agency => (<img key={agency.code} className="agencyLogo" src={agency.logo && agency.logo.url || ""} />))
                    }
                    {
                      (miscellaneous && miscellaneous.length > 0) ?
                        <div className="misc">
                          <h3>Additional Photo</h3>
                          <img src={miscellaneous[0]} alt="Miscellaneous" />
                        </div> : null
                    }
                  </div>
                </Row>
              </div>
            </div>
          }
          {!loading && <Button className="btn btn-blue btn-secondary float-right btn-poster-print" onClick={() => isCrossBorderAgencies ? this.modalToggle() : window.print()}>
            Print
          </Button>}
        </div>
        {isCrossBorderAgencies &&
          <ConfirmationModal
            isOpen={showPrint}
            toggle={() => {
              this.modalToggle();
            }}
            title={'Select an agency to show the contact information'}
            disabledButton={!crossBorderAgency || loading}
            description={
              <WrappedInput id="posterAgency" type="select"
                onChange={(e: any) => this.onChangePosterAgency(e.target.value)} >
                {<option value="">Select One...</option>}
                {this.getAgenciesOptions()}
              </WrappedInput>
            }
            onContinue={() => this.onPrint()}
          />}
        <PosterPrint caseData={this.props.caseData} isCrossBorderPoster={isCrossBorderAgencies} agency={this.getPosterPrintAgency(isCrossBorderAgencies)} />
      </>
    );
  }
}
